import type { SkillCatalogSkill } from "connected-components/skills/types"

const USER_SKILL_ID = /^user\/([0-9a-fA-F-]{36})$/

export function canViewSkillFiles({ tier }: Pick<SkillCatalogSkill, "tier">): boolean {
  return tier === "user" || tier === "shared"
}

export function skillResourceId({ id }: Pick<SkillCatalogSkill, "id">): string | null {
  return USER_SKILL_ID.exec(id)?.[1] ?? null
}

export function canShareSkill(skill: Pick<SkillCatalogSkill, "tier" | "id">): boolean {
  return skill.tier === "user" && skillResourceId(skill) != null
}

export function canDeleteSkill(skill: Pick<SkillCatalogSkill, "tier" | "id">): boolean {
  return skill.tier === "user" && skillResourceId(skill) != null
}

export function canManageSkillShare(skill: Pick<SkillCatalogSkill, "tier">, role: string): boolean {
  return role === "admin" && skill.tier === "shared"
}
